export default "assets/images/logo-small-ed0e76d1.svg";